var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.ok && _vm.in_polygon!==undefined)?_c('div',[_c('b-btn',{staticClass:"mt-1",attrs:{"variant":_vm.in_polygon?'dark':'warning'}},[_c('svg-polygon',{attrs:{"width":"1.5em","height":"1.5em"}}),_vm._v(" "+_vm._s(_vm.polygon_perimeter_distance))],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }